import { Button } from "primereact/button";
import { useEffect, useRef } from "react";
import { useToast } from "sj-ui-toolkit/src/hooks/ToastContext.js";
// Virtual module generated by vite-plugin-pwa at build time - there is no file on
// disk for the import resolver to find. Types come from the vite-plugin-pwa/react
// reference in src/vite-env.d.ts.
// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from "virtual:pwa-register/react";

const isInstalledPwa = (): boolean =>
  window.matchMedia("(display-mode: standalone)").matches ||
  (window.navigator as Navigator & { standalone?: boolean }).standalone === true;

/**
 * Registers the service worker and, in the installed PWA only, offers a
 * user-initiated reload when a new build is waiting.
 *
 * The service worker uses registerType "prompt" rather than "autoUpdate"
 * specifically so this stays a choice: auto-updating would reload the page
 * whenever a deploy lands, which for a learner part-way through a lesson means
 * losing their place. Renders nothing until an update is actually available.
 */
export const PwaUpdatePrompt = (): null => {
  const { showToast } = useToast();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  // showToast is re-created on every ToastProvider render, so a plain dependency
  // array would re-fire the toast. The ref makes this once-per-update.
  const promptShown = useRef(false);

  useEffect(() => {
    if (!needRefresh || promptShown.current || !isInstalledPwa()) {
      return;
    }
    promptShown.current = true;

    showToast({
      severity: "secondary",
      sticky: true,
      closable: true,
      content: (
        <div className="flex flex-col gap-3 p-3">
          <span>A new version of Security Journey is available.</span>
          <Button
            label="Reload to update"
            size="small"
            onClick={() => {
              setNeedRefresh(false);
              void updateServiceWorker(true);
            }}
          />
        </div>
      ),
    });
  }, [needRefresh, promptShown, setNeedRefresh, showToast, updateServiceWorker]);

  return null;
};
